import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * Treatments component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    treatments: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
    },

    titleWrapper: {
      // display: 'flex',
      alignItems: 'center',
      flex: '0 0 auto',
      justifyContent: 'space-between',
      padding: '0 1.6rem 2rem 0',
    },

    panelTitle: {
      '&&': {
        fontSize: '2rem',
        fontWeight: 400,
        lineHeight: '2.5rem',
        color: variables.colorV2.text.header,

        ['@media (min-width: 1024px) and (max-width: 1580px)']: {
          wordBreak: 'break-word',
        },
      },
    },

    elementName: {
      '&&': {
        fontWeight: 800,
      },
    },

    panelContent: {
      backgroundColor: variables.colorV2.panel.background.default,
      borderRadius: '2rem',
      display: 'flex',
      flex: '0 1 auto',
      flexDirection: 'column',
      overflowY: 'auto',
      padding: '2rem 1.6rem',
    },

    contentContainer: {
      height: '100%',
      overflowY: 'scroll',
      width: '100%',
      '& .MuiAccordionDetails-root': {
        padding: '1.6rem 0 0 0 !important',
      },
    },

    addTreatment: {
      // marginRight: theme.spacing(1),

      ['@media (min-width: 1024px) and (max-width: 1580px)']: {
        // width: '100%',
      },
    },

    addEditTreatmentButton: {
      border: `1px solid transparent`,
      // marginLeft: '0.5rem',
      minWidth: '1.6rem',
      padding: '0 0',
      // width: '3.8rem',

      '&.hovered': {
        color: variables.colorV2.link.text.hover,
        border: `0.1rem solid transparent`,
      },
      '&.hovered svg path': {
        stroke: variables.colorV2.button.iconAlternate.stroke.active,
        // fill: variables.colorV2.button.iconAlternate.fill.active,
      },

      '&:hover': {
        border: `0.1rem solid transparent`,
      },

      '& svg path': {
        transition: 'fill 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },

      '&:hover svg path': {
        stroke: variables.colorV2.button.iconAlternate.stroke.hover,
        // fill: variables.colorV2.button.iconAlternate.fill.hover,
      },
    },

    panelTitleHeading: {
      marginBottom: theme.spacing(0.5),
    },

    renameBar: {
      display: 'flex',
      // alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '100%',
    },

    renameField: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },

    renameBarButtons: {
      display: 'flex',
      gap: '10px',
    },

    menu: {
      padding: theme.spacing(1),
      border: `${variables.borderWidth.md} solid ${variables.color.primary.lightGrayDarker}`,
      borderRadius: variables.borderRadius.sm,
    },

    treatmentQuestionBody: {
      marginTop: '15px',
    },

    buttonsWrapper: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: '10px',
    },

    targetingBtn: {
      width: 'fit-content',
    },

    targetTreatments: {
      padding: theme.spacing(2),
      // borderBottom: `${variables.borderWidth.md} solid ${variables.color.primary.lightGrayDarker}`,
      // backgroundColor: variables.color.primary.backgroundLightestGray,
    },

    targetTreatmentsOptions: {
      display: 'flex',
      justifyContent: 'left', // 'space-between',
      alignItems: 'center',
      // marginTop: '-1px',
      padding: '0 0',
      // borderBottom: `${variables.borderWidth.md} solid ${variables.color.primary.lightGrayDarker}`,
      // backgroundColor: variables.color.primary.backgroundLightestGray,
    },

    content: {
      // borderBottom: `${variables.borderWidth.md} solid ${variables.color.primary.lightGrayDarker}`,
      padding: '0 0 1.6rem 0',
    },

    treatmentCards: {
      // borderBottom: `${variables.borderWidth.md} solid ${variables.color.primary.lightGrayDarker}`,
      padding: '0 0 1.6rem 0', //'0 1.6rem 1.6rem 1.6rem',
      overflow: 'auto',
      // height: 'calc(100vh - 310px)',
    },

    root: {
      background: 'red',
      padding: '0 0',
    },

    groupedTreatments: {
      border: `${variables.borderWidth.md} solid ${variables.color.primary.lightGrayDarker}`,
      borderRadius: variables.borderRadius.sm,
    },

    treatmentWrapper: {
      '&:nth-of-type(n)': {
        borderBottom: `${variables.borderWidth.md} solid ${variables.color.primary.lightGrayDarker}`,
      },

      '&:nth-last-of-type(1)': {
        borderBottom: 'none',
      },
    },
  }),
);
